import { useQuery } from '@tanstack/react-query'
import getOtbnAreas, { type OtbnAreasQuery } from '../../services/ruutsApi/getOtbnAreas'
import { queryKeys } from './queryKeys'

export type { OtbnAreasQuery }

export const useOtbnAreas = ({
  farmId,
  query,
}: {
  farmId: string | undefined
  query?: OtbnAreasQuery
}) => {
  const result = useQuery({
    queryKey: queryKeys.otbnAreas(farmId, query),
    queryFn: ({ signal }) => getOtbnAreas({ farmId: farmId as string, query, signal }),
    enabled: !!farmId,
  })

  return {
    otbnAreas: result.data ?? null,
    isLoading: result.isLoading,
    isError: result.isError,
    error: result.error,
  }
}
